import api from './';

export const listarDestinos = params => api.get('/arquivoRetorno/destinos', { params });
const url = (contaUuid, convenioUuid) =>
    `/arquivoRetorno/${encodeURIComponent(contaUuid)}/convenios/${encodeURIComponent(convenioUuid)}/retornos`;
export const listarRetornos = (contaUuid, convenioUuid, params) => api.get(url(contaUuid, convenioUuid), { params });
export const detalharRetorno = (contaUuid, convenioUuid, arquivoUuid, params) =>
    api.get(`${url(contaUuid, convenioUuid)}/${encodeURIComponent(arquivoUuid)}`, { params });
export const importarRetorno = (contaUuid, convenioUuid, arquivo) => {
    const dados = new FormData();
    dados.append('arquivo', arquivo);
    return api.post(url(contaUuid, convenioUuid), dados);
};
